module.exports = __webpack_public_path__ + "97896f04dab2b119743b6a9bdbe6b9e7.jpg";